import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations as fallbackTranslations } from '../data/mock';
import { getAllSiteData } from '../services/api';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');
  const [translations, setTranslations] = useState(fallbackTranslations);
  const [siteConfig, setSiteConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load data from API on mount
  useEffect(() => {
    const loadSiteData = async () => {
      try {
        const data = await getAllSiteData();
        if (data.translations) {
          setTranslations(data.translations);
        }
        if (data.config) {
          setSiteConfig(data.config);
        }
      } catch (error) {
        console.warn('Failed to load site data from API, using fallback:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadSiteData();
  }, []);

  // Get language from URL path
  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/fr')) {
      setLanguage('fr');
    } else if (path.startsWith('/en')) {
      setLanguage('en');
    } else {
      setLanguage('es');
    }
  }, []);

  const t = translations[language] || translations.es || fallbackTranslations.es;

  const changeLanguage = (lang) => {
    setLanguage(lang);
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: changeLanguage, 
      t, 
      translations,
      siteConfig,
      isLoading 
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
